<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-2">
          <div class="mt-4" slot="no-body">
            <span class="text-sm float-right mr-4 font-bold text-warning">* Data in this report is updated every 10 minutes. Please refresh for latest results.</span>
            <vs-input class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" icon="icon-search" icon-pack="feather"
                       v-on:input="onInputSearch" placeholder="Search"
                      v-model="search"/>
            <vs-table
              :data="staff"
              max-items="15" pagination
              :sst="false"
              @sort="handleSort"
              id="raw-material-predicted-use-report-table"
              class="table-dark-inverted table-auto vs-con-loading__container" stripe>>

              <template slot="thead">
                <vs-th class="text-xs" width="15%">RM (ITS CODE)</vs-th>
                <vs-th class="text-xs" width="15%">RM (ITS NAME)</vs-th>
                <vs-th class="text-xs" >COMMITTED RM TO CUSTOMER ORDERS (KG)</vs-th>
                <vs-th class="text-xs" sort-key="total_order_not_manufactured" >NO OF COs</vs-th>
                <vs-th class="text-xs" >CURRENT INVENTORY LEVEL (KG)</vs-th>
                <vs-th class="text-xs" sort-key="shortfall_surplus">SHORTFALL/SURPLUS (KG)</vs-th>
                <vs-th class="text-xs" sort-key="rm_on_order" >
                  <vx-tooltip class="mr-2"
                              position="left"
                              text="This consists of orders in Pending Dispatch, Dispatched, Not Dispatched, Received Status">
                    RM ON ORDER(KG)
                  </vx-tooltip>
                </vs-th>
                <vs-th class="text-xs"  sort-key="shortfall_7days">SHORTFALL <= 7D (KG)</vs-th>
                <vs-th class="text-xs" sort-key="shortfall_8_14days">SHORTFALL 8-14D (KG)</vs-th>
                <vs-th class="text-xs"  sort-key="shortfall_15_21days">SHORTFALL 14D+ (KG)</vs-th>
                <vs-th class="text-xs" width="10%">LAST PRICE UPDATED AT</vs-th>
                <vs-th class="text-xs" width="25%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" style="cursor: pointer" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].company_product_code" class="font-semibold text-sm text-primary">
                    {{ data[indextr].category.prefix}}-{{ data[indextr].company_product_code}}
                  </vs-td>

                  <vs-td class="text-sm" :data="data[indextr].company_product_name">
                    {{data[indextr].company_product_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].total_order_quantity_not_manufactured">
                    {{toFixedNumbers(data[indextr].total_order_quantity_not_manufactured)}}
                  </vs-td>

                  <vs-td :data="data[indextr].total_order_not_manufactured">
                    {{ data[indextr].total_order_not_manufactured}}
                  </vs-td>

                  <vs-td :data="data[indextr].current_stock_level">
                    {{ data[indextr].current_stock_level}}
                  </vs-td>

                  <vs-td :data="data[indextr].shortfall_surplus"
                         v-bind:class="redText(data[indextr].shortfall_surplus)">
                    {{ minusConvertDisplay(data[indextr].shortfall_surplus)}}
                  </vs-td>

                  <vs-td :data="data[indextr].rm_on_order">
                    {{ data[indextr].rm_on_order}}
                  </vs-td>

                                    <vs-td v-bind:class="redText(data[indextr].shortfall_7days)" :data="data[indextr].shortfall_7days">
                                      {{minusConvertDisplay(data[indextr].shortfall_7days)}}
                                    </vs-td>

                                    <vs-td :data="data[indextr].shortfall_8_14days">
                                      {{minusConvertDisplay(data[indextr].shortfall_8_14days)}}
                                    </vs-td>

                                    <vs-td :data="data[indextr].shortfall_15_21days">
                                      {{minusConvertDisplay(data[indextr].shortfall_15_21days)}}
                                    </vs-td>

                                    <vs-td>
                                      {{ data[indextr].price_update ? data[indextr].price_update.price_updated_at : '' }}
                                    </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" position="top" text="view on graph">
                        <vs-button @click.stop="onClickGraph(data[indextr])" color="#AA2EE6" icon="icon-activity" icon-pack="feather"
                                   size="small" type="border"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="mr-2" position="top" text="create PO">
                        <vs-button :color="createPoColorFactory(data[indextr])" @click.stop="onClickCreatePo(data[indextr], createPoColorFactory(data[indextr]))"
                                   icon="icon-arrow-up-right" icon-pack="feather" size="small"
                                   type="filled">create PO
                        </vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">

                      <div class="vx-row md:mb-3 mt-8 p-8" v-if="data[indextr].rm_on_order_details.length > 0" >

                        <div class="vx-col  w-full">
                          <vs-row vs-type="flex">
                            <vs-col
                              vs-align="start" vs-justify="center" vs-type="flex" vs-w="2">
                              <feather-icon class="text-success cursor-pointer" icon="ArchiveIcon"/>
                            </vs-col>
                            <vs-col
                              vs-align="start" vs-justify="start" vs-type="flex" vs-w="10">
                                <span class="text-md">
                                  <h5 class="mb-2">Raw material orders</h5>
                                  <vs-table :data="data[indextr].rm_on_order_details">

                                <template slot="thead">
                                  <vs-th>Order Date</vs-th>
                                  <vs-th>Order Code</vs-th>
                                  <vs-th>Quantity (KG)</vs-th>
                                  <vs-th>Exp Delivery Date</vs-th>
                                  <vs-th>Status</vs-th>
                                </template>

                                <template slot-scope="{data}">
                                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].order_timestamp">
                                      {{ __dateTimeFormatter(data[indextr].order_timestamp) }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].purchase_order_code">
                                      <a class="mt-4" :href="`/pages/raw-materials/orders/${data[indextr].order_id}`">{{data[indextr].purchase_order_code}}</a>
                                    </vs-td>

                                    <vs-td :data="data[indextr].quantity">
                                      {{ data[indextr].quantity }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].order_expected_date">
                                      {{ data[indextr].order_expected_date }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].order_status.name">
                                      {{ data[indextr].order_status.name }}
                                    </vs-td>

                                  </vs-tr>
                                </template>

                              </vs-table>
<!--                                  <span v-for="order in data[indextr].rm_on_order_details" :key="order.purchase_order_code">-->
<!--                                    <vx-tooltip :text="order.purchase_order_code + ' -  view order'" position="right">-->
<!--                                      <a class="mt-4" :href="`/pages/raw-materials/orders/${order.order_id}`">{{order.purchase_order_code}} - {{order.quantity}} KG</a> <br>-->
<!--                                    </vx-tooltip>-->
<!--                                  </span>-->
                                </span>



                            </vs-col>
                          </vs-row>
                        </div>

                      </div>

                      <div class="vx-row">
                        <div class="w-full p-16">
                          <report-single-rm-details-table v-bind:total_orders="data[indextr].total_order_not_manufactured" v-bind:history="data[indextr].history"/>
                        </div>
                      </div>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
<!--            <vs-pagination-->
<!--              :description-items="descriptionItems"-->
<!--              :max-items="perPage"-->
<!--              :size-array="meta.total ? meta.total : 20"-->
<!--              :total="(meta.last_page)? meta.last_page : 0"-->
<!--              class="p-5"-->
<!--              description-->
<!--              description-body="Rows per page"-->
<!--              description-connector="of"-->
<!--              description-title="Records"-->
<!--              v-model="page" v-on:changeMaxItems="changePage">-->
<!--            </vs-pagination>-->

          </div>
        </vx-card>
      </div>
    </div>
    <predicted-use-graph-pop-up ref="predictedUseGraphPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import ReportSingleRmDetailsTable from './ReportSingleRmDetailsTable.vue'
  import PredictedUseGraphPopUp from '@/components/popups/inventory/report-graphs/PredictedUseGraphPopUp'

  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')

  export default {
    name: 'ReportTable',
    data() {
      return {
        staff: [],
        filters: {},
        search: '',
        page: 1,
        total: 0,
        meta: {},
        sort: '',
        perPage: 1000,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      ReportSingleRmDetailsTable,
      PredictedUseGraphPopUp
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    mounted() {
      if(this.$route.query.rm_code) {
        this.filterQuery = `filter[search]=${this.$route.query.rm_code}`
      }
    },
    methods: {
      async refreshData() {
        await this.fetchPredictedUseReportDetails()
      },

      async fetchPredictedUseReportDetails() {
        this.$vs.loading({
          container: '#raw-material-predicted-use-report-table',
          scale: 0.45
        })
        try {
          const {data} = await InventoryRepository.getPredictedUseReportDetails(this.page, `search=${this.search}`, this.perPage, this.sort)

          const arr = data.data.map((obj) => {
            let shortfall_7days = Number(obj.shortfall_7days)
            if(shortfall_7days < 0) {
              obj.sort_flag = 1
            } else if(shortfall_7days > 0) {
              obj.sort_flag = 2
            } else if(shortfall_7days === 0) {
              obj.sort_flag = 3
            }
            return obj
          })

          this.staff = arr.sort((a,b) => (a.sort_flag > b.sort_flag) ? 1 : ((b.sort_flag > a.sort_flag) ? -1 : 0))
          // this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#raw-material-predicted-use-report-table > .con-vs-loading')
      },

      filterQueryUpdate() {
        this.fetchPredictedUseReportDetails()
      },
      handleChangePage(page) {
        this.page = page;
        this.fetchPredictedUseReportDetails()
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      totalOrders(data) {
        return data.reduce((acc, obj) => {
          return acc + Number(obj.orders)
        }, 0)
      },
      async onClickGraph(data) {
        await this.$refs.predictedUseGraphPopUp.openPopup(data)
      },
      toFixedNumbers(number) {
        return (Number(number)).toFixed(2)
      },
      toFixedThreeNumbers(number) {
        return (Number(number)).toFixed(3)
      },
      redText(value) {
        if (Number(value) < 0) {
          return 'text-danger'
        }
      },
      onClickCreatePo(data, color) {
        const id = data.id
        const qty = Math.abs(data.shortfall_surplus).toFixed(2)
        if(data.rm_on_order > 0) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: 'Confirm',
            text: 'You have an order inbound for this raw Material. Do you still wish to raise another PO?',
            accept: this.confirmCreatePo,
            parameters: [id, qty]
          })
        } else {
          let params = [id, qty]
          this.confirmCreatePo(params)
        }
      },
      confirmCreatePo(params) {
        this.$router.replace({path: `/pages/raw-materials?step=1&open=${params[0]}&qty=${params[1]}`}, function () {
          location.reload()
        })
      },
      minusConvertDisplay(value) {
        return Math.abs(value).toFixed(2)
      },
      createPoColorFactory(data) {
        if (Number(data.shortfall_7days > 0)) {
          return '#FFBF00'
        } else if (Number(data.shortfall_7days) < 0) {
          return 'danger'
        } else {
          return 'primary'
        }
      },
      handleSort(key, active) {
        if (key) {
          active = (active === 'desc') ? "-" : '';
          this.sort = active + key;
          this.fetchPredictedUseReportDetails()
        }
      },
      onInputSearch() {
        this.inputSearch(this)
      },
      inputSearch: _.debounce( async (vm) => {
          vm.fetchPredictedUseReportDetails()
      }, 500),
    },
    watch: {
      page() {
        this.fetchPredictedUseReportDetails()
      },
      perPage() {
        this.fetchPredictedUseReportDetails()
      },
    },
  }
</script>


<style scoped>

</style>
